"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContentImage;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var s = {
  image: function image(height, width) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("top:0;left:0;right:0;bottom:0;border-radius:2px;height:", height, "px;width:", width, "px;")
    );
  }
};

function ContentImage(props) {
  var name = props.name,
      image = props.image,
      height = props.height,
      width = props.width;
  return _react.default.createElement("img", {
    src: image,
    alt: name,
    className: s.image(height, width)
  });
}